import { render, staticRenderFns } from "./SubTaskModal.vue?vue&type=template&id=674adf70&scoped=true&"
import script from "./SubTaskModal.vue?vue&type=script&lang=ts&"
export * from "./SubTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./SubTaskModal.vue?vue&type=style&index=0&id=674adf70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674adf70",
  null
  
)

export default component.exports